import {autobind} from 'core-decorators';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {formatDateTime} from '../../core/utils';
import styles from './styles.css';

@autobind
export default class CreditDetail extends Component {
    static propTypes = {
        creditDetail: PropTypes.object,
    };

    render() {
        const {creditDetail} = this.props;

        if (!creditDetail) return null;

        return (
            <div className={styles.root}>
                {creditDetail.description && (
                    <div className={styles.description}>{creditDetail.description}</div>
                )}
                <div className={styles.counts}>
                    {Boolean(creditDetail.cornBagCount) && (
                        <div>Bolsas de Maíz: <strong>{creditDetail.cornBagCount}</strong></div>
                    )}
                    {Boolean(creditDetail.sunflowerBagCount) && (
                        <div>Bolsas de Girasol: <strong>{creditDetail.sunflowerBagCount}</strong></div>
                    )}
                </div>
                <div>
                    Última actualización: <strong>{formatDateTime(creditDetail.date)}</strong>
                </div>
                <div className={styles.moreInfo}>
                    <a href='/bases-y-condiciones/#calculo-del-credito' target='_blank'>
                        Mas información
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/credit-detail/index.js